import { Injectable } from '@angular/core';
import {
  DisplayMode,
  OfferCategoryOption,
  OfferChannelOption,
  OfferCityOption,
  OfferQueryParams,
  OfferSortOption,
} from '@rd/types';

export const defaultQueryParams: OfferQueryParams = {
  channel: '',
  category: '',
  city: '',
  sort: '-score_by_recommended',
  searchByBrand: '',
};

export const categoryOptions: OfferCategoryOption[] = [
  { name: 'offer.filter_modal.category.all', value: '' },
  { name: 'offer.filter_modal.category.dining', value: 'dining' },
  { name: 'offer.filter_modal.category.shopping', value: 'shopping' },
  { name: 'offer.filter_modal.category.lifestyle', value: 'lifestyle' },
  { name: 'offer.filter_modal.category.travel', value: 'travel' },
  { name: 'offer.filter_modal.category.others', value: 'others' },
];

export const channelOptions: OfferChannelOption[] = [
  { name: 'offer.filter_modal.channel.all', value: '' },
  { name: 'offer.filter_modal.channel.online', value: 'online' },
  { name: 'offer.filter_modal.channel.in_store', value: 'offline' },
];

export const cityOptions: OfferCityOption[] = [
  { name: 'offer.filter_modal.city.select_a_city', value: '' },
  { name: 'offer.filter_modal.city.sydney', value: 'sydney' },
  { name: 'offer.filter_modal.city.melbourne', value: 'melbourne' },
  { name: 'offer.filter_modal.city.adelaide', value: 'adelaide' },
  { name: 'offer.filter_modal.city.perth', value: 'perth' },
  { name: 'offer.filter_modal.city.brisbane', value: 'brisbane' },
];

export const sortOptions: OfferSortOption[] = [
  { name: 'offer.sort_modal.recommended', value: '-score_by_recommended' },
  { name: 'offer.sort_modal.best_rated', value: '-score_by_best_rated' },
  { name: 'offer.sort_modal.nearby', value: '-score_by_distance' },
  { name: 'offer.sort_modal.recently_added', value: '-created_at' },
  { name: 'offer.sort_modal.a_z', value: 'brand' },
  { name: 'offer.sort_modal.z_a', value: '-brand' },
  { name: 'offer.sort_modal.expiring_soonest', value: 'end_time' },
];

@Injectable()
export class OfferSettingService {
  defaultQueryParams = defaultQueryParams;
  categoryOptions = categoryOptions;
  channelOptions = channelOptions;
  cityOptions = cityOptions;
  sortOptions = sortOptions;
  offerImageRatio = '1:1';
  renderCategoryIcon = false;
  hasInfiniteScrolling = false;
  showOfferDetailButtonAnalyticsData = false;
  sendOfferAnalyticsDataAtPageLoad = true;
  iconMap: Record<string, string> = {
    dining: 'icon-offer-category-dining',
    shopping: 'icon-offer-category-retail',
    lifestyle: 'icon-offer-category-lifestyle',
    travel: 'icon-offer-category-travel',
    others: 'icon-offer-category-others',
  };
  protected renderHowItWorksSubtitle = true;
  protected displayLongDescription = false;
  protected renderBreadcrumb = true;
  protected breadcrumbDisplayMode: {
    desktop: DisplayMode;
    mobile: DisplayMode;
  } = {
    desktop: 'stacked',
    mobile: 'embedded',
  };

  public getRenderCategoryIcon(): boolean {
    return this.renderCategoryIcon;
  }

  public shouldRenderHowItWorksSubtitle(): boolean {
    return this.renderHowItWorksSubtitle;
  }

  public shouldDisplayLongDescription(): boolean {
    return this.displayLongDescription;
  }

  public getRenderBreadcrumb(): boolean {
    return this.renderBreadcrumb;
  }

  getBreadcrumbDisplayMode() {
    return this.breadcrumbDisplayMode;
  }
}
